import { Injectable, InjectionToken, Inject } from '@angular/core';
import { BaseAppConfig } from '@base-shared/interfaces/config';

export const ConfigService = new InjectionToken<BaseAppConfig>('BaseAppConfig')

@Injectable()
export class BaseConfigService {

  private _client: BaseAppConfig;

  constructor(@Inject(ConfigService) private config) {
    this._client = config;
  }

  get client() {
    return this._client;
  }
}
